import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { AttachmentPillData } from '../store/schema/AttachmentPillData';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

export default function getRecentAttachments(
    attachmentPillsData: AttachmentPillData[]
): AttachmentType[] {
    return attachmentPillsData.map(pillsData => {
        const attachment = getAttachment(pillsData.attachmentId!!);
        return attachment.model;
    });
}
